<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <!-- <span class="mr-10px">数据标准库:</span> -->
    <el-select
      size="small"
      placeholder="请选择标准库"
      v-model="standardId"
      filterable
      :loading="standardLoading"
      @change="standardSwitch"
    >
      <el-option
        v-for="item in standardList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <el-row class="mt-10px" :gutter="20">
      <el-col :span="6" v-for="(item, index) in dataBoxList" :key="index">
        <el-card>
          <div class="h-100px flex justify-between items-center">
            <div class="flex-grow-3 text-center flex justify-center items-center">
              <div :class="item.className" class="w-45px h-45px bg-no-repeat bg-center"></div>
            </div>
            <div class="flex-grow-2">
              <p class="text-18px text-hex-303133">{{ item.title }}</p>
              <div class="text-30px pt-20px flex justify-start">
                <p>{{ item.value }}</p>
                <p class="text-14px text-hex-666 flex flex-col items-end ml-65px justify-end">
                  {{ item.unit }}
                </p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mt-10px">
      <div class="float-left">
        <el-date-picker
          v-model="timeRange"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
        ></el-date-picker>
        <el-select
          class="mx-10px"
          placeholder="流程状态"
          size="small"
          v-model="taskStatus"
          filterable
          clearable
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button @click="clickCreate" v-if="activeName === '2'" type="primary" size="small"
          >新增</el-button
        >
        <el-button type="primary" size="small" @click="searchList">搜索</el-button>
        <!-- <el-button type="primary" size="small">导出</el-button> -->
      </div>
    </el-row>
    <el-tabs v-model="activeName">
      <el-tab-pane label="采集数据表清单" name="entity">
        <el-table
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          class="mt-10px"
          :data="entityTableData"
          border
          height="440px"
          v-loading="entityTableLoading"
          ref="entityTableRef"
        >
          <el-table-column type="index" width="75" sortable label="序号"></el-table-column>
          <el-table-column prop="batchCode" label="批次号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="runTime" label="提交日期" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="submitUserName"
            label="提交人"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="entityName"
            label="数据表名称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="count" label="数据量" show-overflow-tooltip></el-table-column>
          <el-table-column prop="taskStatusStr" label="流程状态" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="100px">
            <template #default="{ row }">
              <el-button @click="goApprovalPage(row)" size="mini">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="float-right mt-20px h-32px"
          background
          @size-change="entityTableSizeChange"
          @current-change="getEntityRankList"
          :current-page.sync="entityTablePage.pageNo"
          :page-size.sync="entityTablePage.pageSize"
          layout="total, sizes ,prev, pager, next"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="entityTablePage.totalCount"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="采集任务清单" name="task">
        <el-table
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          class="mt-10px"
          :data="taskTableData"
          border
          height="500px"
        >
          <el-table-column type="index" width="75" sortable label="序号"></el-table-column>
          <el-table-column label="任务批号"></el-table-column>
          <el-table-column label="数据源"></el-table-column>
          <el-table-column label="任务名称"></el-table-column>
          <el-table-column label="任务类型"></el-table-column>
          <el-table-column label="上一次执行时间"></el-table-column>
          <el-table-column label="最近修改人"></el-table-column>
          <el-table-column label="任务状态"></el-table-column>
          <el-table-column label="操作"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import DataMonitorTaskService from '@/services/dataMonitorTaskService'

export default {
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  data() {
    return {
      standardId: '', // 标准库id
      standardList: [], // 标准库列表
      standardLoading: false, // 标准库列表loading
      entityGatherCount: '', // 实体采集任务数
      taskGatherCount: '', // 任务采集任务数
      gatherLoading: false, // 采集任务数loading
      entityGatherDataCount: '', // 实体采集记录总数
      taskGatherDataCount: '', // 任务采集记录总数
      gatherDataLoading: false, // 采集记录总数loading
      timeRange: [], // 搜索时间范围
      entityTableData: [], // 实体对象采集清单列表
      entityTableLoading: false, // 实体对象采集清单列表loading
      entityTablePage: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
      }, // 实体对象采集清单列表分页器
      taskTableData: [],
      activeName: 'entity',
      statusList: [
        // {
        //   label: '待审批',
        //   value: 1,
        // },
        {
          label: '审批中',
          value: 2,
        },
        {
          label: '审批通过',
          value: 4,
        },
        {
          label: '审批拒绝',
          value: 5,
        },
      ], // 状态列表
      taskStatus: null, // 审批状态
      dataBoxList: [
        {
          className: 'data-source-box',
          title: '数据表采集个数',
          value: 0,
          unit: '个',
        },
        {
          className: 'data-collect-box',
          title: '数据表采集量',
          value: 0,
          unit: '条',
        },
        {
          className: 'data-count-box',
          title: '任务采集任务数',
          value: 0,
          unit: '个',
        },
        {
          className: 'data-number-box',
          title: '任务采集记录总数',
          value: 0,
          unit: '条',
        },
      ], // 数据渲染列表
    }
  },
  methods: {
    /**
     * @description 跳转到审批页面
     * @param {Object} row 实体采集信息
     */
    goApprovalPage(row) {
      this.$router.push({
        path: `${this.basePath}/legacy-resource/data-approval/approval`,
        query: {
          batchId: row.instanceId,
          showWorkFlow: false,
        },
      })
    },

    /**
     * @description 获取标准库列表
     */
    async getStandardList() {
      this.standardLoading = true
      const res = await StandardManagementService.getList()
      this.standardLoading = false
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        this.standardId = this.standardList[0]?.id
      }
    },

    /**
     * @description 获取实体采集任务数和任务采集任务数
     */
    async getGatherCount() {
      this.gatherLoading = true
      const [entityGatherCount, taskGatherCount] = await Promise.all([
        this.getTaskCount(0),
        this.getTaskCount(1),
      ])
      this.gatherLoading = false
      if (entityGatherCount !== null) {
        this.entityGatherCount = entityGatherCount
        this.dataBoxList[0].value = `${entityGatherCount}`
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      if (taskGatherCount !== null) {
        this.taskGatherCount = taskGatherCount
        this.dataBoxList[2].value = `${taskGatherCount}`
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },

    /**
     * @description 获取采集任务数
     * @param {Number} taskType 1.etl采集任务 0.实体对象采集
     * @returns 采集任务数
     */
    async getTaskCount(taskType) {
      const res = await DataMonitorTaskService.getTaskTotalCount({
        standardId: this.standardId,
        taskType,
      })
      if (res && res.code === 0) {
        return res.data
      }
      return null
    },

    /**
     * @description 获取实体采集记录总数和任务采集记录总数
     */
    async getGatherDataCount() {
      this.gatherDataLoading = true
      const [entityGatherDataCount, taskGatherDataCount] = await Promise.all([
        this.getTaskDataTotalCount(0),
        this.getTaskDataTotalCount(1),
      ])
      this.gatherDataLoading = false
      if (entityGatherDataCount !== null) {
        this.entityGatherDataCount = entityGatherDataCount
        this.dataBoxList[1].value = `${entityGatherDataCount}`
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      if (taskGatherDataCount !== null) {
        this.taskGatherDataCount = taskGatherDataCount
        this.dataBoxList[3].value = `${taskGatherDataCount}`
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },

    /**
     * @description 获取采集任务数据总数
     * @param {Number} taskType 1.etl采集任务 0.实体对象采集
     * @returns 采集任务数据总数
     */
    async getTaskDataTotalCount(taskType) {
      this.taskDataTotalLoading = true
      const res = await DataMonitorTaskService.getTaskDataTotalCount({
        standardId: this.standardId,
        taskType,
      })
      this.taskDataTotalLoading = false
      if (res && res.code === 0) {
        return res.data
      }
      return null
    },

    /**
     * @description 获取实体对象采集排行列表
     */
    async getEntityRankList() {
      const payload = {
        standardId: this.standardId,
        maxResultCount: this.entityTablePage.pageSize, // 每页多少条
        skipCount: (this.entityTablePage.pageNo - 1) * this.entityTablePage.pageSize, // 跳过多少条
      }
      if (this.timeRange && this.timeRange.length) {
        payload.startTime = this.timeRange[0]
        payload.endTime = this.timeRange[1]
      }
      if (this.taskStatus) {
        payload.taskStatus = this.taskStatus
      }
      this.entityTableLoading = true
      const res = await DataMonitorTaskService.getPagedTaskTotalList(payload)
      this.entityTableLoading = false
      if (res && res.data && res.code === 0) {
        this.entityTableData = res.data
        this.entityTablePage.totalCount = res.totalCount
        this.entityTableData.forEach((item) => {
          item.taskStatusStr = ''
          if (item.taskStatus) {
            const statusItem = _.find(this.statusList, (status) => {
              return status.value === item.taskStatus
            })
            if (statusItem) {
              item.taskStatusStr = statusItem.label
            }
          }
        })
        this.$nextTick(() => {
          this.$refs.entityTableRef && this.$refs.entityTableRef.doLayout()
        })
      }
    },

    /**
     * @description 实体对象采集清单列表分页数变化
     */
    entityTableSizeChange() {
      this.entityTablePage.pageNo = 1
      this.getEntityRankList()
    },

    /**
     * @description 列表查询
     */
    searchList() {
      if (this.activeName === 'entity') {
        this.entityTableSizeChange()
      }
    },

    /**
     * @description 标准库切换
     */
    standardSwitch() {
      this.getGatherCount()
      this.getGatherDataCount()
      this.getEntityRankList()
    },

    /**
     * @description 点击新增
     */
    clickCreate() {
      this.$router.push({
        name: 'createTask',
      })
    },
  },
  async created() {
    if (this.$route.query?.type) {
      this.activeName = this.$route.query.type
    }
    await this.getStandardList()
    this.standardSwitch()
  },
}
</script>

<style lang="scss" scoped>

.data-source-box,
.data-collect-box,
.data-count-box,
.data-number-box {
  background-size: 100% 100%;
}
.data-source-box {
  background-image: url('../../assets/images/data_source.png');
}
.data-collect-box {
  background-image: url('../../assets/images/data_collect.png');
}
.data-count-box {
  background-image: url('../../assets/images/data_all_count.png');
}
.data-number-box {
  background-image: url('../../assets/images/data_all_number.png');
}
.flex-grow-2 {
  flex-grow: 2;
}
.flex-grow-3 {
  flex-grow: 3;
}

</style>
